/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import ClassroomRouteLinkItem from './ClassroomRouteLinkItem';
import CalendarIcon from 'icons/CalendarIcon';
import {useUserContext} from 'app/UserContext';
import {useMidasJsonApi} from 'app/hooks';

const messages = defineMessages({
  title: {id: 'navigation.calendar'},
});

const CalendarItem = () => {
  const [{classroom}] = useUserContext();

  const [response] = useMidasJsonApi({
    url: `/midas/rest/pd-section/${classroom.sectionID}?fields=id`,
    expectedStatus: [200, 404],
  });

  // If a PD section does exist, don't show the calendar link (this item)
  if (response.json?.section) {
    return null;
  }

  return (
    <ClassroomRouteLinkItem
      iconBefore={CalendarIcon}
      route="midas/classroom/calendar"
      title={messages.title}
    />
  );
};

export default CalendarItem;
